import { render, staticRenderFns } from "./honor.vue?vue&type=template&id=38d70c87&scoped=true"
import script from "./honor.vue?vue&type=script&lang=js"
export * from "./honor.vue?vue&type=script&lang=js"
import style0 from "./honor.vue?vue&type=style&index=0&id=38d70c87&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d70c87",
  null
  
)

export default component.exports